import { render } from "./MyInbox.vue?vue&type=template&id=3f37e43d&scoped=true"
import script from "./MyInbox.vue?vue&type=script&lang=js"
export * from "./MyInbox.vue?vue&type=script&lang=js"

import "./MyInbox.vue?vue&type=style&index=0&id=3f37e43d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f37e43d"]])

export default __exports__